import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth.service';
import { AppProfile } from '../../../shared/app-profile/app-profile';

@Injectable({
  providedIn: 'root'
})
export class OrganizationDetailsService {
  constructor(
    private readonly http: HttpClient, 
    private readonly authSvc: AuthService,
    private readonly appProfile: AppProfile
  ) {}

  getOrgDetails(orgId: string, token: string): Observable<any> {
    const headers = this.authSvc.getCommonHeaders(token, '1.0.0');
    return this.http.get<any>(`${this.appProfile.epUs}/organization-ms/organization/${orgId}`, { headers });
  }
}
